<template>
    <div>
        <div v-if="label" class="text-xs text-muted-foreground mb-1">{{ label }}</div>
        <div class="flex items-center space-x-4">
            <Select :model-value="String(modelValue || '')" @update:model-value="handleChange" :disabled="loading || disabled">
                <SelectTrigger :class="triggerClass" :style="{ width: width, maxWidth: maxWidth }">
                    <SelectValue :placeholder="placeholder" />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem v-for="option in options" :key="option.key || option.value" :value="String(option.key || option.value)">
                        {{ option.name }}
                    </SelectItem>
                </SelectContent>
            </Select>
            <slot name="inputRight" />
        </div>
    </div>
</template>

<script setup>
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const props = defineProps({
    options: {
        type: Array,
        default: () => []
    },
    modelValue: {
        type: [String, Number],
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
    loading: {
        type: Boolean,
        default: false
    },
    label: {
        type: String,
        default: ''
    },
    placeholder: {
        type: String,
        default: 'Select an option'
    },
    width: {
        type: String,
        default: 'auto'
    },
    maxWidth: {
        type: String,
        default: '16rem'
    },
    triggerClass: {
        type: String,
        default: 'h-9'
    }
});

const emit = defineEmits(['update:modelValue']);

const handleChange = (value) => {
    emit('update:modelValue', value);
};
</script>
